import { useFlags } from '@terminal/stores/use-flags/useFlags';
import { useSubscription } from '@terminal/stores/use-subscription/useSubscription';

export const useIsFollowedThemesEnabled = () => {
  const isFollowedThemesFlagEnabled = useFlags(state =>
    state.getFeatureFlagState('followed_themes')
  );
  const isProUser = useSubscription(state => !state.isBasicOrLightUser());

  return isFollowedThemesFlagEnabled && isProUser;
};
